import { render, staticRenderFns } from "./PageContentArea.vue?vue&type=template&id=721eadcf&scoped=true"
import script from "./PageContentArea.vue?vue&type=script&lang=js"
export * from "./PageContentArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721eadcf",
  null
  
)

export default component.exports